export default __webpack_public_path__ + "static/media/klaw@2x.23f1af5f.png";